let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6xkn1")).then(() => parcelRequire('hLoZh'));